<app-login-container>
	@if (userProfile) {
		<div>
			<div class="row-center small-margin-top">
				<mat-icon class="select-role-avatar">person</mat-icon>
			</div>
			<h2 class="row-center margin-sixteen" i18n="Greets the user @@Hi_user">Hi {{ userProfile.user.firstName }}</h2>
			<app-loading-indicator diameter="50">
				<div class="row-center" data-automation-id="choose_role" i18n="Prompts user to select a role@@choose_role">
					Choose a Role
				</div>
				<mat-action-list class="select-role-container">
					@for (item of userProfile.availableAssignedRoles; track item.id) {
						<app-active-role-item
							[assignedRole]="item"
							(roleSelected)="onRoleSelected($event)"
							[attr.data-automation-id]="'role-' + item.id"
						></app-active-role-item>
					}
				</mat-action-list>
			</app-loading-indicator>
		</div>
	}
</app-login-container>
